<template>
    <div>
        <h3 v-b-tooltip.hover="`（${detailForm?.name}）`" class="text-truncate" style="position: absolute; top: -40px; left: 40px">
            （{{ detailForm?.name }}）
        </h3>
        <div class="card-header">
            <div class="d-flex">
                <div class="title--screen" style="white-space: nowrap">
                    {{ $t('managerForm.analytics.dataManagement') }}
                </div>
            </div>
        </div>
        <div class="card-body">
            <template>
                <TableFilterBlock :blockList="listBlockForm" @onQuery="onHandleGetQueryTable" />
                <h3 class="mb-0 title--screen">
                    回答結果 <span>件数 ({{ configPage.total }})</span>
                </h3>
                <div class="d-flex justify-content-end mb-2">
                    <button type="button" class="btn btn-common btn-success" @click="() => (configModalDownloadData.model = true)">
                        <i class="ri-file-download-line"></i>データダウンロード
                    </button>
                </div>
                <TableListComponent
                    :heightTable="`calc(100vh - 630px)`"
                    :config="configTable"
                    :dataList="listDataTable"
                    :isLoading="isLoading"
                    :configPage.sync="configPage"
                    :stickyAction="true"
                    @onChangePage="getList()"
                    @sort="handleSort"
                >
                    <template #row="{ row }">
                        <tr>
                            <td class="text-left">{{ row.submit_index }}</td>
                            <td>
                                <div class="el-table__cell text-left">
                                    {{ formatDateCommon(row?.submitted_at, 'dateTimeJP') }}
                                </div>
                            </td>
                            <template v-for="(item, idx) in listBlockForm">
                                <td :key="`td-${idx}`" :style="getStyleDeletedCol(item.is_deleted)">
                                    <div class="el-table__cell text-left">
                                        <template v-if="item.block_type === ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE">
                                            <div v-b-tooltip.hover :title="getValueBlockForm(row.submit_results, idx)?.file_name">
                                                {{ getValueBlockForm(row.submit_results, idx)?.file_name }}
                                            </div>
                                        </template>
                                        <template v-else-if="item.block_type === ALL_BLOCK_TYPE.BLOCK_TEXTAREA">
                                            <div
                                                class="el-table__cell"
                                                v-b-tooltip.hover="{ title: getValueBlockForm(row.submit_results, idx), html: true }"
                                                v-html="renderLineBreaks(getValueBlockForm(row.submit_results, idx))"
                                            ></div>
                                        </template>
                                        <template v-else>
                                            <div class="el-table__cell" v-b-tooltip.hover :title="getValueBlockForm(row.submit_results, idx)">
                                                {{ getValueBlockForm(row.submit_results, idx) ?? '' }}
                                            </div>
                                        </template>
                                    </div>
                                </td>
                            </template>
                            <template v-for="(item, idx) in listMailLogs">
                                <td :key="`td-addr-mail-${idx}`" :style="getStyleDeletedCol(item.is_deleted)">
                                    <div class="el-table__cell text-left">
                                        {{ getValueColumnMail(item, row?.email_logs)?.to_address }}
                                    </div>
                                </td>
                                <td :key="`td-status-mail-${idx}`" :style="getStyleDeletedCol(item.is_deleted)">
                                    <div class="el-table__cell text-left">
                                        {{ getValueColumnMail(item, row?.email_logs)?.status_label }}
                                    </div>
                                </td>
                            </template>
                            <td>
                                <div class="el-table__cell text-left">
                                    {{ row.winning_text }}
                                </div>
                            </td>
                            <td>
                                <div class="el-table__cell text-left">
                                    <span v-if="row.winning_flag === '当選'" class="badge badge-success">{{ row.winning_flag }}</span>
                                    <span v-else-if="row.winning_flag" class="badge badge-secondary">{{ row.winning_flag }}</span>
                                </div>
                            </td>
                            <td class="sticky_action">
                                <div class="row-data-medium">
                                    <a href="javascript:void(0)" :class="`btn btn-sm btn-info mr-2`" @click="handleOpenModalDetail(row)">{{
                                        $t('btn.detail')
                                    }}</a>
                                    <a
                                        v-if="checkPermission('form.delete_analytics')"
                                        href="javascript:void(0)"
                                        :class="`btn btn-sm btn-danger`"
                                        @click="handleDeleteAnalytics(row)"
                                        >{{ $t('btn.delete') }}</a
                                    >
                                </div>
                            </td>
                        </tr>
                    </template>
                </TableListComponent>
            </template>
        </div>

        <ModalCommon :id="`ModalAnalyticsDetail`" :config="configModalAnalyticsDetail" @close="() => (configModalAnalyticsDetail.model = false)">
            <template>
                <div class="card">
                    <div class="card-header">
                        <h3 class="mb-0 title--screen">共通データ</h3>
                    </div>
                    <div class="card-body">
                        <div class="form-group row">
                            <label class="col-sm-3">回答ID</label>
                            <div class="col-sm-9">
                                {{ currentAnalyticsRow?.submit_index }}
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3">IPアドレス</label>
                            <div class="col-sm-9">
                                {{ currentAnalyticsRow?.meta_data?.ip_address }}
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3">ブラウザ</label>
                            <div class="col-sm-9">
                                {{ currentAnalyticsRow?.meta_data?.browser }}
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3">リンク元</label>
                            <div class="col-sm-9">
                                <a :href="`${currentAnalyticsRow?.meta_data?.url}`" target="_blank">
                                    {{ `${currentAnalyticsRow?.meta_data?.url}` }}
                                </a>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-sm-3">回答日時</label>
                            <div class="col-sm-9">
                                {{ formatDateCommon(currentAnalyticsRow.submitted_at, 'dateTimeJP') }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card mt-3">
                    <div class="card-header">
                        <h3 class="mb-0 title--screen">フロントページ</h3>
                    </div>
                    <div class="card-body">
                        <div v-for="(item, index) in listBlockForm" :key="index" class="form-group row">
                            <label class="col-sm-4">{{ item.block_name }}</label>
                            <div class="col-sm-8">
                                <div v-if="item.block_type === ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE" class="">
                                    <p class="mb-0">
                                        {{ getValueBlockForm(currentAnalyticsRow?.submit_results, index)?.file_name }}
                                    </p>
                                    <div
                                        v-if="
                                            arrExtension.includes(
                                                getValueBlockForm(currentAnalyticsRow?.submit_results, index)?.extension?.toLowerCase()
                                            )
                                        "
                                        class="position-relative media-preview"
                                    >
                                        <b-img
                                            v-b-tooltip.hover="getValueBlockForm(currentAnalyticsRow?.submit_results, index)?.origin_name"
                                            class="media-preview__content"
                                            thumbnail
                                            fluid
                                            :src="getValueBlockForm(currentAnalyticsRow?.submit_results, index).path"
                                            :alt="getValueBlockForm(currentAnalyticsRow?.submit_results, index)?.origin_name"
                                        ></b-img>
                                    </div>
                                    <div
                                        v-else-if="
                                            VIDEO_EXTENSIONS.includes(
                                                getValueBlockForm(currentAnalyticsRow?.submit_results, index)?.extension?.toLowerCase()
                                            )
                                        "
                                        class="position-relative media-preview"
                                    >
                                        <VideoCommon
                                            :src="getValueBlockForm(currentAnalyticsRow?.submit_results, index).path"
                                            class="media-preview__content"
                                        />
                                    </div>
                                    <a v-else :href="getValueBlockForm(currentAnalyticsRow?.submit_results, index)?.path" download>{{
                                        getValueBlockForm(currentAnalyticsRow?.submit_results, index)?.origin_name
                                    }}</a>
                                </div>
                                <span v-else-if="item.block_type !== ALL_BLOCK_TYPE.BLOCK_TEXTAREA">
                                    {{ getValueBlockForm(currentAnalyticsRow?.submit_results, index) }}
                                </span>
                                <div v-else v-html="renderLineBreaks(getValueBlockForm(currentAnalyticsRow?.submit_results, index))"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </ModalCommon>

        <ModalCommon id="ModalDownloadData" :config="configModalDownloadData" @close="() => (configModalDownloadData.model = false)">
            <DownloadData type="manager" :detailForm="detailForm" :queryTableFilter="getQueryString()" :configModal="configModalDownloadData" />
        </ModalCommon>
    </div>
</template>

<script>
import appConfig from '@/app.config';
import TableListComponent from '@/components/TableList/main.vue';
import ModalCommon from '@/components/Modal/main.vue';
import TableFilterBlock from './table-filter.vue';
import DownloadData from '../download-data/main.vue';
import VideoCommon from '@/components/Video/main.vue';

import { checkPermission, getInfoUserLocalStorage, onHandleShowConfirm } from '@/utils/handlers';
import { configs } from '../../constants';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { managerFormMethods, masterMethods } from '@/state/helpers';
import { formatDateCommon, renderLineBreaks, IMAGE_EXTENSIONS, VIDEO_EXTENSIONS } from '@/utils/format';
import { showMessage } from '@/utils/messages';
import { isRolePartner } from '@/views/pages/require/handlers.js';
import {
    getValueColumnMail,
    handleSyncMailHeaders,
    getFormattedHeader,
    getStyleDeletedCol
} from '@/views/pages/phase2/manager-form/analytics/handlers.js';

export default {
    name: 'AnalyticsFormList',
    page: {
        title: 'キャンペーン一覧',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    props: {
        detailForm: {
            type: Object,
            default: () => ({})
        }
    },
    components: {
        TableListComponent,
        ModalCommon,
        TableFilterBlock,
        DownloadData,
        VideoCommon
    },
    data() {
        return {
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE,
            configTable: configs.configTableAnalytics(),
            configPage: configs.configPage,
            configModalAnalyticsDetail: configs.configModalAnalyticsDetail,
            configModalDownloadData: configs.configModalDownloadData,
            listDataTable: [],
            isLoading: true,
            currentAnalyticsRow: {},
            sortId: 'desc',
            listBlockForm: [],
            queryTableFilter: '',
            arrExtension: IMAGE_EXTENSIONS,
            VIDEO_EXTENSIONS,
            listMailLogs: []
        };
    },
    methods: {
        checkPermission,
        ...managerFormMethods,
        ...masterMethods,
        formatDateCommon,
        renderLineBreaks,
        getValueColumnMail,
        getStyleDeletedCol,

        onHandleGetQueryTable(query) {
            this.queryTableFilter = query;
            this.getList();
        },

        handleSort(item) {
            this.sortId = item.sort.type;
            this.getList();
        },

        handleOpenModalDetail(row) {
            this.configModalAnalyticsDetail.id_form = row.id;
            this.configModalAnalyticsDetail.title = this.$t('btn.detail');
            this.configModalAnalyticsDetail.model = true;
            this.currentAnalyticsRow = row;
        },

        async handleDeleteAnalytics(row) {
            const payload = {
                id: this.$route.query.id,
                idBlock: row.id
            };
            const confirmDeleteLogic = await onHandleShowConfirm({
                title: '論理削除のためフォームのデータはすべて非表示になります。',
                text: '',
                icon: 'warning',
                cancelButtonText: 'キャンセル'
            });
            if (confirmDeleteLogic) {
                try {
                    const dataRes = await this.deleteAnalytics(payload);
                    if (dataRes?.code !== 200) {
                        showMessage(dataRes.code, this.$bvToast, this.$t(dataRes.message));
                        return;
                    }
                    showMessage(dataRes.code, this.$bvToast, '論理削除が完了しました。');
                    this.getList();
                } catch (error) {
                    console.log('error', error);
                }
            }
        },

        getQueryString() {
            let query = [`page=${this.configPage.page}`, `limit=${this.configPage.limit}`, `sorts[id]=${this.sortId}`];
            if (this.queryTableFilter) {
                query.push(this.queryTableFilter);
            }
            return query.join('&');
        },

        async getList() {
            let query = this.getQueryString();
            this.isLoading = true;
            try {
                const data = await this.getAnalytics({ id: this.$route.query.id, query: query });
                this.listDataTable = data.data.map((itemData) => {
                    itemData.submit_results.forEach((itemSubmit) => {
                        this.listBlockForm.forEach((itemBlock) => {
                            if (itemBlock.id === itemSubmit.block_id) {
                                itemSubmit.error_messages = itemBlock.error_messages;
                                itemSubmit.extension = itemBlock.extension;
                                itemBlock.submit_results.push(itemSubmit);
                            }
                        });
                    });
                    return itemData;
                });

                const { listMailLogs, headers } = handleSyncMailHeaders(data.data, this.listBlockForm, this.configTable.headers);

                // Remove winning_text and winning_flag if they are in headers, so we can append them at the very end
                const finalHeaders = headers.filter((h) => h.label !== '当選テキスト' && h.label !== '当選フラグ');
                finalHeaders.push({ label: '当選テキスト', width: 120 });
                finalHeaders.push({ label: '当選フラグ', width: 120 });

                this.listMailLogs = listMailLogs;
                this.configTable.headers = finalHeaders;

                this.configPage.total = data._metadata.total;
                this.configPage.limit = data._metadata.limit * 1;
                if (!this.listDataTable.length && this.configPage.page !== 1) {
                    this.configPage.page = 1;
                    this.getList();
                } else {
                    this.isLoading = false;
                }
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        async getMasterCampaign() {
            this.isLoading = true;
            try {
                let query = 'all/campaigns';
                if (isRolePartner()) {
                    query += `?has[partner]=${getInfoUserLocalStorage().partner_id}`;
                }
                const dataRes = await this.listMaster(query);
                this.listDataCampaign = dataRes;
            } catch (error) {
                console.log('error', error);
            } finally {
                this.isLoading = false;
            }
        },

        async getListBlockFromAnalytics() {
            try {
                const data = await this.getListBlockOfForm(this.$route.query.id);
                const sortedData = data?.sort((a, b) => a.order_index - b.order_index) ?? [];
                this.listBlockForm = sortedData.map((item) => {
                    return {
                        ...item,
                        ...getFormattedHeader(item),
                        submit_results: [],
                        options: item.list_options
                    };
                });
                this.configTable.headers.push(...this.listBlockForm);
            } catch (error) {
                console.log('error', error);
            }
        },
        getValueBlockForm(submitResults, index) {
            if (!submitResults || !Array.isArray(submitResults)) return '';
            const blockForm = this.listBlockForm[index];
            const result = submitResults.find((item) => item.block_id === blockForm.id);
            const resultValue = result?.answers[0];
            const listValueToString =
                result?.answers
                    ?.map((item) => {
                        return item.is_custom_value ? `${result.extension.setting_others.label_other}(${item.value ?? ''})` : item.value ?? '';
                    })
                    ?.toString() ?? '';
            switch (blockForm.block_type) {
                case ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE:
                    return resultValue?.file;
                case ALL_BLOCK_TYPE.BLOCK_RADIO:
                    if (resultValue?.is_custom_value) {
                        return `${result.extension.setting_others.label_other}(${resultValue.value ?? ''})`;
                    } else {
                        return result ? (Array.isArray(resultValue.value) ? resultValue.value.join(', ') : resultValue.value) : '';
                    }
                case ALL_BLOCK_TYPE.BLOCK_CHECKBOX:
                    return listValueToString;
                default:
                    return result ? (Array.isArray(resultValue.value) ? resultValue.value.join(', ') : resultValue.value) : '';
            }
        }
    },

    async mounted() {
        await this.getListBlockFromAnalytics();
        this.getList();
        this.getMasterCampaign();
    }
};
</script>

<style lang="scss" scoped>
.media-preview {
    width: 200px;
    height: 200px;

    &__content {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        border-radius: 10px;
    }
}
</style>
